// extracted by mini-css-extract-plugin
export default {"tasks":"ZM-z","task":"_M-z","svg":"aN-z","text":"bN-z"};